import { render, staticRenderFns } from "./PackagingTypesTableAdmin.vue?vue&type=template&id=157ccf3a&scoped=true"
import script from "./PackagingTypesTableAdmin.vue?vue&type=script&lang=js"
export * from "./PackagingTypesTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157ccf3a",
  null
  
)

export default component.exports